import * as React from "react";
import {HistoryEvent} from "../HistoryEvent";

interface IProps {
    knownCharacters: string,
    history: HistoryEvent[],
    characterOrder: string[],
    showDebug: boolean,
}

interface IState {}

export class CharactersScores extends React.Component<IProps, IState> {
    public render() {
        if(!this.props.showDebug) {
            return "";
        }
        const characters = this.props.knownCharacters.split('').map((char: string) => {
            const relevantHistory = this.props.history.filter((event: HistoryEvent) => event.word.includes(char));
            const correct = relevantHistory.filter((event: HistoryEvent) => {
                return event.wasCorrect
            });
            const incorrect = relevantHistory.filter((event: HistoryEvent) => {
                return !event.wasCorrect
            });
            let consecutive = 0;
            let noFailure = true;
            relevantHistory.sort((lhs: HistoryEvent, rhs:HistoryEvent) => lhs.index > rhs.index ? 1: -1).reverse().forEach(event => {
               if(event.wasCorrect && noFailure) {
                   consecutive += 1;
               } else {
                   noFailure = false;
               }
            });
            return(
                <li key={char}>
                    <span>{char}</span>
                    <span>correct: {correct.length}</span>
                    <span>incorrect: {incorrect.length}</span>
                    <span>consecutive: {consecutive}</span>
                </li>
            )
        });
        return (
            <div>
                <ul className="knownCharacters">
                    {characters}
                </ul>
                order: {this.props.characterOrder.join('')}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/CharactersScores.tsx